// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table_block[data-v-9f1cfcac]{background:#fff;border-radius:10px;padding:15px}.page_out[data-v-9f1cfcac]{width:100%;text-align:right}", ""]);
// Exports
module.exports = exports;
